import React, { useState } from "react";
import { Element } from "react-scroll";
import "./Blog.css";
import Tabs from "./Tabs";
import TabContent from "./TabContent";
import MainCard from "./MainCard";
import SubItemsModal from "./SubItemsModal";
import ArticleDetailModal from "./ArticleDetailModal";

const Blog = (props) => {
  const isMobile = props.isMobile || false;
  const [activeTab, setActiveTab] = useState(0);
  const [selectedMainItem, setSelectedMainItem] = useState(null);
  const [selectedSubItem, setSelectedSubItem] = useState(null);
  const [featuredItems, setFeaturedItems] = useState([]);

  // بيانات تجريبية
  const tabsData = [
    {
      title: "عناوين رئيسية",
      items: [
        {
          id: 1,
          title: "استراتيجيات تسويق المشاريع العقارية في العصر الرقمي",
          subItems: [
            {
              id: 1,
              title: "الاستفادة من الذكاء الاصطناعي وتحليل البيانات",
              content: `
              هل تعلم أن الذكاء الاصطناعي يمكنه أن يتنبأ باحتياجات عملائك قبل أن يعبرّوا عنها؟ إليك كيف :
                
              - تخصيص العروض: بناءً على تصفح العميل للسابق، يمكن للأنظمة الذكية اقتراح العقارات التي تتناسب مع اهتماماته .
              
              - خدمة عملاء أذكى: الشات بوت يمكنه الرد على استفسارات العملاء فوراً، وتحديد المواعيد تلقائياً .
              
              - تحليل السوق: يمكن للذكاء الاصطناعي دراسة اتجاهات الأسعار والمساعدة في تحديد الأسعار التنافسية.
              `,
            },
            {
              id: 2,
              title:
                "الجولات الافتراضية والواقع المعزز: لن تحتاج إلى زيارة ميدانية!",
              content: `
              هذه التقنيات لم تعد رفاهية؛ بل أصبحت من الأساسيات. لماذا ؟

              - تجربة غامرة: تتيح للعميل استكشاف كل ركن في العقار كما لو كان حاضراً .
              
              - جذب عملاء من خارج المدينة: يمكن لأي شخص في أي مكان في العالم "زيارة" المشروع.
              
              - رؤية أفضل للمساحة: بإضافة التأثيث الافتراضي، يمكن للعميل أن يتخيل كيف ستبدو الوحدة بعد تأثيثها .
              `,
            },
            {
              id: 3,
              title: "وسائل التواصل الاجتماعي: منصة التفاعل المثالية",
              content: `
              من فيسبوك إلى تيك توك، أصبحت وسائل التواصل الاجتماعي ساحة حقيقية للتواصل مع العملاء. كيف تستفيد منها ؟

              - فيديوهات قصيرة وجذابة: مثل عرض "يوم في حياة وكيل عقارات" أو "تحولات عقارية" .
              
              - إعلانات مستهدفة بدقة: يمكنك اختيار الجمهور المناسب حسب الموقع والاهتمامات .
              
              - بناء مجتمع تفاعلي: من خلال الرد على التعليقات وبث الجولات المباشرة.
              `,
            },
            {
              id: 4,
              title: "محتوى ذو قيمة وتهيئة لمحركات البحث (SEO)",
              content: `
                المحتوى الجيد هو ما يجعلك مصدرًا موثوقًا في عيون عملائك. كيف تبدأ ؟

                - ركز على المحتوى المحلي: اكتب عن أفضل المدارس في الحي، أو تقارير عن أسواق منطقة معينة .
                
                - استخدم الكلمات المفتاحية بذكاء: لتحسين ظهورك في نتائج البحث.
                `,
            },
          ],
          download: require("../../pdf/استراتيجيات_تسويق_المشاريع_العقارية_في_العصر_الرقمي.pdf"),
        },
        // {
        //   id: 2,
        //   title: "الذكاء الاصطناعي",
        //   subItems: [
        //     {
        //       id: 1,
        //       title: "تعلم الآلة",
        //       content: "تعلم الآلة هو مجال من مجالات الذكاء الاصطناعي...",
        //     },
        //     {
        //       id: 2,
        //       title: "الشبكات العصبية",
        //       content: "الشبكات العصبية الاصطناعية تحاكي عمل الدماغ البشري...",
        //     },
        //   ],
        // },
        // {
        //   id: 3,
        //   title: "التصميم UX/UI",
        //   subItems: [
        //     {
        //       id: 1,
        //       title: "مبادئ التصميم",
        //       content: "المبادئ الأساسية في تصميم تجربة المستخدم...",
        //     },
        //     {
        //       id: 2,
        //       title: "أدوات التصميم",
        //       content: "أفضل الأدوات الحديثة لمصممي الواجهات...",
        //     },
        //   ],
        // },
      ],
    },
    {
      title: "مقالات مميزة",
      items: featuredItems,
    },
    {
      title: "أحدث المقالات",
      items: [
        // {
        //   id: 4,
        //   title: "أحدث تقنيات 2024",
        //   subItems: [
        //     {
        //       id: 1,
        //       title: "Web3 والميتافيرس",
        //       content: "استكشاف عالم Web3 والميتافيرس والتقنيات الناشئة...",
        //     },
        //     {
        //       id: 2,
        //       title: "التطور في الذكاء الاصطناعي",
        //       content: "أحدث التطورات في مجال الذكاء الاصطناعي...",
        //     },
        //   ],
        // },
        // {
        //   id: 5,
        //   title: "أمن المعلومات",
        //   subItems: [
        //     {
        //       id: 1,
        //       title: "الحماية من الاختراق",
        //       content: "أفضل ممارسات الحماية من الاختراقات الإلكترونية...",
        //     },
        //   ],
        // },
      ],
    },
  ];

  const addToFeatured = (item) => {
    if (!featuredItems.some((featured) => featured.id === item.id)) {
      setFeaturedItems([...featuredItems, item]);
    }
  };

  const currentTabData = tabsData[activeTab];

  return (
    <Element name="Blog">
      <section className="Blog">
        <div className="Blog-left">
          <div className="tabs-container">
            <Tabs
              tabs={tabsData.map((tab) => tab.title)}
              activeTab={activeTab}
              onTabChange={setActiveTab}
              isMobile={isMobile}
            />

            <TabContent isMobile={isMobile}>
              {currentTabData.items.length > 0 ? (
                currentTabData.items.map((item) => (
                  <MainCard
                    key={item.id}
                    item={item}
                    onCardClick={() => setSelectedMainItem(item)}
                    onAddToFeatured={() => addToFeatured(item)}
                    isMobile={isMobile}
                  />
                ))
              ) : (
                <div className="empty-state">
                  <p>لا توجد مقالات في هذا القسم بعد</p>
                </div>
              )}
            </TabContent>

            {selectedMainItem && (
              <SubItemsModal
                item={selectedMainItem}
                onClose={() => setSelectedMainItem(null)}
                onSubItemClick={setSelectedSubItem}
                isMobile={isMobile}
              />
            )}

            {selectedSubItem && (
              <ArticleDetailModal
               Download={selectedMainItem?.download}
                subItem={selectedSubItem}
                onClose={() => setSelectedSubItem(null)}
                isMobile={isMobile}
              />
            )}
          </div>
        </div>

        <div className="Blog-right">
          <p>04</p>
          <span></span>
          <label>مدونتنا</label>
        </div>
      </section>
    </Element>
  );
};

export default Blog;
